<template>
  <div class="" style="padding-left: 3%; padding-right: 3%; background-color: #F8F9FA;">
    <v-row class="mb-2">
      <v-col cols="6">
        <img width="17" height="17" src="@/assets/icons/back-icon.png" class="mt-5 ml-0" style="cursor: pointer;" @click="goBack()">
        <span class="header-title ml-0">
          แก้ไขสิทธิ์การใช้งานบุคคล
        </span>
      </v-col>
      <v-col cols="6" class="pt-0 pb-0 d-flex align-center justify-end mt-4 action-top-btn">
        <v-btn width="18%" class="button-color-outline ma-0" outlined dark @click="goBack()">ยกเลิก</v-btn>
        <!-- <v-btn width="18%" class="ma-2 mr-5" color="#3776E9" dark @click="submitData()">บันทึกข้อมูล</v-btn> -->
        <v-btn width="18%" class="button-color ma-2 mr-2" dark @click="dialogConfirm = true">บันทึกข้อมูล</v-btn>
      </v-col>
    </v-row>
    <div style="background-color: #fff; max-height: auto;" class="pt-1 px-3">
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
      >
        <!-- <v-row class="rounded-lg" style="background-color: #fff;" justify="center">
          <v-col cols="10" sm="12" md="6" lg="6">
            <div
              class="pt-0 d-flex flex-row align-center justify-end"
              color="grey lighten-2"
              flat
              tile
            >
              <span class="ra-span-text-highlight mb-4 mr-2">ค้นหา: </span>
              <v-autocomplete
                v-model="dataSearchEmployee"
                :items="itemUser"
                outlined
                dense
                chips
                small-chips
                label="ค้นหาพนักงาน"
                multiple
                item-text="dataShow"
                item-value="employeeId"
                @change="searchEmployee(dataSearchEmployee)"
              >
              <template #selection="{ item, index }">
                <span v-if="index === 0" class="mx-1" style="color: #333333">{{item.titleTh}} {{item.firstNameTh}} {{item.lastNameTh}} </span>
                <span v-if="index === 1" class="mx-0" style="color: #333333">(+{{ dataSearchEmployee.length - 1 }} เพิ่มเติม) </span>
              </template>
              </v-autocomplete>
              <v-tooltip bottom>
                <span class="label-table-action">ค้นหาพนักงาน</span>
              </v-tooltip>
            </div>
          </v-col>
        </v-row> -->
      <OverlayLoading :loading="loading" />
      <v-col cols="10" class="mx-auto px-0 mb-5">
        <v-data-table
          v-if="employeeList.length !== 0"
          :headers="headers"
          :items="employeeList"
          class="border-table-employee text-no-wrap mt-1"
          item-key="_id"
          :single-expand="singleExpand"
          :expanded.sync="expanded"
          :loading="loading"
          loader-height=0
          loading-text="Loading... Please wait"
          :footer-props="{
            'items-per-page-options': [15, 30, 50, 100, -1],
            'items-per-page': 15
          }"
          :server-items-length="total || -1"
          @update:items-per-page="changePerPage"
          @update:page="changePage"
          disable-sort
        >
          <template v-slot:[`item.no`]="{ item }">
            {{ (perPage*(page-1)) + employeeList.indexOf(item)+1 }}
          </template>
          <!-- <template v-slot:[`item.actions`]="{ item }">
            <v-row class="d-flex">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    rounded
                    dark
                    icon
                    class="ra-border-button mt-3 mb-3 ml-3"
                    @click="checkRemove(item)"
                  >
                  <template v-slot>
                    <v-icon dark color="#D1392B" size="19px">mdi-delete-outline</v-icon>
                  </template>
                  </v-btn>
                </template>
                <span class="label-table-action">รายชื่อสมาขิก</span>
              </v-tooltip>
            </v-row>
          </template>
          <template v-slot:item.data-table-expand="{ expand, isExpanded, item }">
            <v-row class="d-flex px-3">
              <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      rounded
                      dark
                      icon
                      class="ra-border-button mt-3 mb-3 ml-3"
                      @click="checkRemove(item)"
                    >
                    <template v-slot>
                      <v-icon dark color="#D1392B" size="19px">mdi-delete-outline</v-icon>
                    </template>
                    </v-btn>
                  </template>
                  <span class="label-table-action">รายชื่อสมาขิก</span>
                </v-tooltip>
                <v-btn
                  class="mt-3"
                  color="primary"
                  text
                  icon
                  v-show="item.children"
                  @click="expand(!isExpanded)"
                >
                  <v-icon v-if="!isExpanded">mdi-chevron-down</v-icon>
                  <v-icon v-else>mdi-chevron-up</v-icon>
                </v-btn>
            </v-row>
          </template> -->
        </v-data-table>
        <v-row class="mt-12" justify=center v-if="employeeList.length !== 0">
          <v-col cols="10">
            <span class="ra-head-text-bold">สิทธิ์การใช้งานเพิ่มเติมของพนักงาน</span>
          </v-col>
          <v-col cols="2" class="pt-0 d-flex flex-row align-center justify-end">
            <v-btn
                outlined
                color="#fff"
                dark
                class=""
                @click="add('main')"
              >
              <v-icon left dark color="#2BA197" size="14px">fa-plus</v-icon>
              <span class="text-sub-color ra-text-in-button-editRolePerson">
                เพิ่มสิทธิ์การใช้งานหลัก
              </span>
              </v-btn>
          </v-col>
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
          <v-col cols="12">
            <div v-for="(input,k) in detailRole" :key="k">
              <v-card
              class="mx-auto px-0 mb-5"
            >
              <v-row style="background-color: #EFF4FD" class="pa-0 ma-0">
                <v-col cols="10">
                  <v-col cols="10" class="pt-0 pa-0 d-flex flex-row justify-start">
                  <span class="txt-head">ลำดับที่ {{ k+1 }}<span class="ml-1"></span><span class="txt-font" style="color: grey; font-size: 14px;">&nbsp;(</span><span style="color: red;">*</span><span class="txt-font" style="color: grey; font-size: 14px;">กรอกข้อมูลให้ครบถ้วน)</span></span>
                  </v-col>
                </v-col>
                <v-col v-if="detailRole.length > 1" cols="2" class="pt-2 pa-2 d-flex flex-row align-center justify-end">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        dark
                        icon
                        tile
                        class="ra-border-button mr-2"
                        @click="checkRemove(k, 'role')" v-show="k || ( !k && detailRole.length > 1)">
                        <template v-slot>
                          <v-icon dark color="#D1392B" size="19px">mdi-delete-outline</v-icon>
                        </template>
                      </v-btn>
                    </template>
                    <span class="label-table-action">ลบข้อมูล</span>
                  </v-tooltip>
                </v-col>
              </v-row>
              <v-row class="pa-5">
                <v-col cols="4" class="form-control" style="margin-top: 0%;">
                  <span class="txt-font">ชื่อสิทธิ์การใช้งาน</span>
                  <v-select
                    v-model="detailRole[k].roleName"
                    :items="itemRoleType"
                    item-text="name"
                    item-value="_id"
                    @change="filterDetail(detailRole[k].roleName, k)"
                    :rules="inputRules"
                    outlined
                    label="เลือกชื่อสิทธิ์การใช้งาน"
                    dense
                  ></v-select>
                </v-col>
                <v-col cols="4" class="form-control">
                  <span class="txt-font">ประเภทสิทธิ์การใช้งาน</span>
                  <v-text-field
                    v-model="detailRole[k].roleType"
                    label="ประเภทสิทธิ์การใช้งาน"
                    readonly
                    solo
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="4" class="form-control">
                  <span class="txt-font">รายละเอียดสิทธิ์การใช้งาน</span>
                  <v-textarea
                    v-model="detailRole[k].description"
                    label="รายละเอียดสิทธิ์การใช้งาน"
                    readonly
                    disabled
                    solo
                    dense
                    height="20"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-card>
            </div>
          </v-col>
        </v-row>
        <v-row class="mt-12" justify=center v-if="employeeList.length !== 0">
          <v-col cols="10">
            <!-- <span class="ra-head-text-bold">สิทธิ์การใช้งานเพิ่มเติมของพนักงาน</span> -->
            <span class="ra-head-text-bold">สิทธิ์การใช้งานเพิ่มเติมของพนักงาน<span class="ml-1"></span><span class="txt-font" style="color: grey; font-size: 14px;">&nbsp;(</span><span style="color: red;">*</span><span class="txt-font" style="color: grey; font-size: 14px;">ไม่จำเป็นต้องกรอกข้อมูล)</span></span>
          </v-col>
          <v-col cols="2" class="pt-0 d-flex flex-row align-center justify-end">
            <v-btn
              outlined
              color="#fff"
              dark
              class=""
              @click="add('more')"
            >
            <v-icon left dark color="#2BA197" size="14px">fa-plus</v-icon>
            <span class="text-sub-color ra-text-in-button-editRolePerson">
              เพิ่มสิทธิ์การใช้งานเพิ่มเติม
            </span>
            </v-btn>
          </v-col>
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
          <v-col cols="12">
            <div v-for="(input,k) in detailRoleMore" :key="k">
              <v-card
              class="mx-auto px-0 mb-5"
            >
              <v-row style="background-color: #EFF4FD" class="pa-0 ma-0">
                <v-col cols="10">
                  <v-col cols="10" class="pt-0 pa-0 d-flex flex-row justify-start">
                  <span class="txt-head">ลำดับที่ {{ k+1 }}<span class="ml-1"></span><span class="txt-font" style="color: grey; font-size: 14px;">&nbsp;(</span><span style="color: red;">*</span><span class="txt-font" style="color: grey; font-size: 14px;">กรอกข้อมูลให้ครบถ้วน)</span></span>
                  </v-col>
                </v-col>
                <v-col cols="2" class="pt-2 pa-2 d-flex flex-row align-center justify-end">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        dark
                        icon
                        tile
                        class="ra-border-button mr-2"
                        @click="checkRemove(k, 'roleMore')" v-show="k || ( !k && detailRoleMore.length > 0)">
                        <template v-slot>
                          <v-icon dark color="#D1392B" size="19px">mdi-delete-outline</v-icon>
                        </template>
                      </v-btn>
                    </template>
                    <span class="label-table-action">ลบข้อมูล</span>
                  </v-tooltip>
                </v-col>
              </v-row>
              <v-row class="px-5">
                <v-col cols="4" class="form-control" style="margin-top: 0%;">
                  <span class="txt-font">เครือบริษัท</span>
                  <v-select
                    v-model="detailRoleMore[k].groupCompany"
                    :items="detailRoleMore[k].itemGroupCompany"
                    item-text="groupCompanyNameTh"
                    item-value="_id"
                    :rules="inputRules"
                    @change="getSelectorGroup(detailRoleMore[k].groupCompany, k)"
                    outlined
                    dense
                    placeholder="เลือกเครือบริษัท"
                  />
                </v-col>
                <v-col cols="4" class="form-control">
                  <span class="txt-font">บริษัท</span>
                  <v-select
                    v-model="detailRoleMore[k].company"
                    :items="detailRoleMore[k].itemCompany"
                    item-text="companyFullNameTh"
                    item-value="_id"
                    outlined
                    dense
                    placeholder="เลือกบริษัท"
                  />
                </v-col>
              </v-row>
              <v-row class="px-5">
                <v-col cols="4" class="form-control" style="margin-top: 0%;">
                  <span class="txt-font">ชื่อสิทธิ์การใช้งาน</span>
                  <v-select
                    v-model="detailRoleMore[k].roleName"
                    :items="itemRoleType"
                    item-text="name"
                    item-value="_id"
                    @change="filterDetailMore(detailRoleMore[k].roleName, k)"
                    :rules="inputRules"
                    outlined
                    label="เลือกชื่อสิทธิ์การใช้งาน"
                    dense
                  ></v-select>
                </v-col>
                <v-col cols="4" class="form-control">
                  <span class="txt-font">ประเภทสิทธิ์การใช้งาน</span>
                  <v-text-field
                    v-model="detailRoleMore[k].roleType"
                    label="ประเภทสิทธิ์การใช้งาน"
                    readonly
                    solo
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="4" class="form-control">
                  <span class="txt-font">รายละเอียดสิทธิ์การใช้งาน</span>
                  <v-textarea
                    v-model="detailRoleMore[k].description"
                    label="รายละเอียดสิทธิ์การใช้งาน"
                    readonly
                    disabled
                    solo
                    dense
                    height="20"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-card>
            </div>
          </v-col>
        </v-row>
      </v-col>
      </v-form>
    </div>
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card height="170px">
        <v-card-title class="ra-head-text-bold justify-center pa-5">ต้องการลบข้อมูลนี้ ใช่หรือไม่?</v-card-title>
        <v-card-text class="justify-center text-center">
        <span class="ra-head-text justify-center">คุณแน่ใจหรือว่าต้องการลบข้อมูลนี้</span>
        </v-card-text>
        <v-card-actions class="">
          <v-spacer></v-spacer>
          <v-btn class="ra-button1" color="#1654C6" outlined @click="dialogDelete = false">ยกเลิก</v-btn>
          <v-btn class="ra-button1" color="#1654C6" dark @click="remove(itemConfirmDelete)">ลบข้อมูล</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogConfirm" max-width="500px">
      <v-card height="170px">
        <v-card-title class="ra-head-text-bold justify-center pa-5">ต้องการบันทึกข้อมูลนี้ ใช่หรือไม่?</v-card-title>
        <v-card-text class="justify-center text-center">
        <span class="ra-head-text justify-center">คุณแน่ใจหรือว่าต้องการบันทึกข้อมูลนี้</span>
        </v-card-text>
        <v-card-actions class="">
          <v-spacer></v-spacer>
          <v-btn class="button-color-outline" outlined @click="dialogConfirm = false">ยกเลิก</v-btn>
          <v-btn class="button-color" dark @click="submitData()">ยืนยัน</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="text-center">
      <v-row>
        <v-snackbar
        v-model="snackbar"
        :timeout="timeout"
        :color="snackbarColor"
        text
        top
        app
      >
      <v-icon left dark small :color="snackbarColor">fa-check-circle</v-icon>
      <span :style="{ 'color': `${snackbarColor}` }">{{ text }}</span>
      </v-snackbar>
      </v-row>
    </div>
  </div>
</template>

<script>
import {
  getSelectorGroup,
  getSelectRoleCompany,
  getlistRolePersonById,
  getUserByKeyword,
  hostImageUrlv3,
  updateRolePerson
} from '@/API/API'
import { OverlayLoading } from '@/components/index'
import swal from 'sweetalert'

export default {
  name: 'create-new-department',
  components: {
    OverlayLoading
  },
  data () {
    return {
      // colorLock: 'red',
      typeList: '',
      dialogConfirm: false,
      expanded: [],
      singleExpand: true,
      multiLine: true,
      snackbar: false,
      timeout: 2000,
      snackbarColor: '',
      text: '',
      dialogDelete: false,
      tokenUser: '',
      loading: false,
      detailRole: [],
      selectType: '',
      selectOrgChart: '',
      dataSearchEmployee: '',
      itemOrgChart: [],
      itemUser: [],
      itemUserMemory: [],
      selectGroupCompany: '',
      selectCompany: '',
      selectLine: [],
      selectDepartment: [],
      selectDivision: [],
      selectAgency: [],
      selectWorkgroup: [],
      itemGroupCompany: [],
      itemCompany: [],
      itemLine: [],
      itemDepartment: [],
      itemDivision: [],
      itemAgency: [],
      itemWorkgroup: [],
      itemRoleType: [],
      roleCompanyList: [],
      detailRoleMore: [],
      chartPickerSelector: [],
      render: true,
      positionData: [{
        positionName: '',
        companyName: '',
        positionLevel: ''
      }],
      valid: true,
      total: -1,
      perPage: 15,
      page: 1,
      inputRules: [
        v => !!v || 'กรุณากรอกข้อมูล'
      ],
      employeeListMemory: [],
      employeeList: [
        // {
        //   no: 1,
        //   _id: '1212xx',
        //   employeeId: '12363',
        //   approverName: 'นายสมพงษ์ อิอิ',
        //   position: 'ตำแหน่ง xxxx',
        //   companyName: 'INET',
        //   email: 'kookkai@one.th',
        //   // userImg: 'https://picsum.photos/200',
        //   failed_image: true
        // }
      ],
      headers: [
        {
          text: 'ลำดับ',
          align: 'center',
          value: 'no'
        },
        { text: 'ชื่อ - นามสกุล', value: 'approverName' },
        { text: 'รหัสพนักงาน', value: 'employeeId' },
        { text: 'สายบังคับบัญชา', value: 'orgChartName' },
        { text: 'ตำแหน่ง', value: 'position' },
        { text: 'บริษัท', value: 'companyName' }
        // { text: 'จัดการ', value: 'data-table-expand', sortable: false, width: '120px', align: 'start fixed', class: 'column-fix' }
      ]
    }
  },
  created () {
    this.tokenUser = this.$store.state.token
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    // this.getListRole()
    if (!this.$store.state.token) {
      this.goLogin()
    } else {
      this.getlistRoleCompanyById(this.$route.params.id)
    }
    this.getUser()
    this.getRoleCompanyList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    changePerPage (value) {
      this.perPage = value
      // this.initDataTable()
    },
    changePage (value) {
      this.page = value
      // this.initDataTable()
    },
    goBack () {
      this.$router.go(-1)
    },
    addEmployeeList () {
      this.employeeList = this.employeeListMemory
      this.dataSearchEmployee = ''
    },
    async getlistRoleCompanyById (value) {
      this.loading = true
      const obj = {
        empId: value
      }
      try {
        const res = await getlistRolePersonById(obj, this.tokenUser)
        if (res.success) {
          // if (res.result[0].groupCompanyId === null) {
          //   this.selectGroupCompany = ''
          // } else {
          //   this.selectGroupCompany = res.result[0].groupCompanyId
          // }
          // this.selectCompany = res.result[0].companyId
          // this.selectType = res.result[0].orgChartType
          // this.selectOrgChart = res.result[0].orgChartId
          // this.editId = res.result[0]._id
          // this.employeeList = res.result.user
          for (let index = 0; index < res.result.user.length; index++) {
            this.employeeList.push({
              // no: 1,
              _id: res.result.user[index]._id,
              employeeId: res.result.user[index].employeeId,
              approverName: res.result.user[index].titleTh + ' ' + res.result.user[index].firstNameTh + ' ' + res.result.user[index].lastNameTh,
              position: res.result.user[index].positions,
              companyName: res.result.user[index].companyFullNameTh,
              orgChartName: res.result.user[index].orgChartName,
              // email: res.result.user[index]._id,
              // userImg: 'https://picsum.photos/200',
              failed_image: true
            })
          }
          for (let index = 0; index < res.result.permissionsMore.length; index++) {
            this.detailRoleMore.push({
              groupCompany: res.result.permissionsMore[index].groupCompanyId,
              company: res.result.permissionsMore[index].companyId,
              roleName: res.result.permissionsMore[index]._id,
              roleType: res.result.permissionsMore[index].typeName,
              description: res.result.permissionsMore[index].comment,
              colorLock: 'success'
            })
            await this.getSelectorGroup(this.detailRoleMore[index].groupCompany, [index])
          }
          for (let index = 0; index < res.result.permissions.length; index++) {
            this.detailRole.push({
              roleName: res.result.permissions[index]._id,
              roleType: res.result.permissions[index].typeName,
              description: res.result.permissions[index].comment,
              colorLock: 'success'
            })
          }
          this.loading = false
        } else {
          console.log(res)
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async getSelectorGroup (value, index) {
      this.loading = true
      // var temp = []
      const obj = {
        groupCompanyId: value,
        companyId: '',
        section: ''
      }
      try {
        const res = await getSelectorGroup(this.tokenUser, obj)
        if (res.success) {
          this.detailRoleMore[index].itemGroupCompany = res.groupCompany
          this.detailRoleMore[index].itemCompany = res.company
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async getRoleCompanyList () {
      this.loading = true
      try {
        const res = await getSelectRoleCompany(this.tokenUser)
        if (res.success) {
          this.roleCompanyList = res.result
          for (let index = 0; index < this.roleCompanyList.length; index++) {
            this.itemRoleType.push({
              name: this.roleCompanyList[index].name,
              _id: this.roleCompanyList[index]._id
            })
          }
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async searchEmployee (value) {
      // this.loading = true
      // this.loadingUsers = true
      const obj = {
        search: value
      }
      try {
        const res = await getUserByKeyword(obj, this.tokenUser)
        if (res.result[0]) {
          this.id = res.result[0]._id
          this.fNameTh = res.result[0].name
          this.employeeId = res.result[0].employeeId
          this.position = res.result[0].position.positionName
          this.email = res.result[0].email
          this.img = res.result[0].userImg
          this.companyName = res.result[0].companyName
          this.companyId = res.result[0].companyId
          this.employeeList.push({
            _id: res.result[0]._id,
            employeeId: res.result[0].employeeId,
            approverName: res.result[0].name,
            position: res.result[0].position.positionName,
            orgChartName: res.result[0].orgChartName,
            companyName: res.result[0].companyName,
            email: res.result[0].email
          })
          this.dataSearchEmployee = ''
          // if (this.img === '') {
          //   this.img = `${hostImageUrlv3}/_/${res.result[0].emailOneId}`
          // } else {
          //   this.img = `${hostImageUrlv3}/${res.result[0].userImg}/${res.result[0].emailOneId}`
          // }
        } else {
          // this.dataSearchEmployee = ''
          swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
            button: false,
            timer: 2000
          })
        }
      } catch (error) {
        console.log(error)
        // this.dataSearchEmployee = ''
        swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
          button: false,
          timer: 2000
        })
      } finally {
        // this.loading = false
        this.loadingUsers = false
      }
    },
    async getUser () {
      // this.loading = true
      this.loadingUsers = true
      var temp = []
      const obj = {
        search: ''
      }
      try {
        const res = await getUserByKeyword(obj, this.tokenUser)
        if (res.success) {
          if (res.result.length) {
            res.result.map((el, index) => {
              if (el.userImg === '') {
                el.userImg = `${hostImageUrlv3}/_/${el.emailOneId}`
              } else {
                el.userImg = `${hostImageUrlv3}/${el.userImg}/${el.emailOneId}`
              }
              temp.push({
                no: index + 1,
                dataShow: el.employeeId + ' - ' + el.name,
                ...el
              })
            })
          }
          // temp = res.result
          this.itemUser = temp
          this.dialogApprover = true
          this.loading = false
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
        this.loadingUsers = false
      }
    },
    filterDetail (val, i) {
      this.detailRole[i].roleType = []
      this.detailRole[i].description = []
      var filterValue = this.roleCompanyList.filter(r => {
        if (r._id === val) {
          return r
        }
      })
      this.detailRole[i].roleType = filterValue[0].type.typeName
      this.detailRole[i].description = filterValue[0].comment
    },
    filterDetailMore (val, i) {
      this.detailRoleMore[i].roleType = []
      this.detailRoleMore[i].description = []
      var filterValue = this.roleCompanyList.filter(r => {
        if (r._id === val) {
          return r
        }
      })
      this.detailRoleMore[i].roleType = filterValue[0].type.typeName
      this.detailRoleMore[i].description = filterValue[0].comment
    },
    add (type) {
      if (type === 'main') {
        this.detailRole.push({
          roleName: '',
          roleType: '',
          description: ''
        })
        this.text = 'เพิ่มสิทธิ์การใช้งานหลัก'
        this.snackbarColor = 'success'
        this.snackbar = true
      } else if (type === 'more') {
        this.detailRoleMore.push({
          groupCompany: '',
          company: '',
          roleName: '',
          roleType: '',
          description: '',
          itemGroupCompany: [],
          itemCompany: []
        })
        this.getSelectorGroup('', this.detailRoleMore.length - 1)
        this.text = 'เพิ่มสิทธิ์การใช้งานเพิ่มเติม'
        this.snackbarColor = 'success'
        this.snackbar = true
      }
    },
    checkRemove (item, type) {
      this.dialogDelete = true
      this.itemConfirmDelete = item
      this.typeList = type
    },
    remove (item) {
      // this.employeeList.splice(item, 1)
      if (this.typeList === 'employee') {
        this.employeeList.splice(this.employeeList.indexOf(item), 1)
        this.itemConfirmDelete = []
        this.dialogDelete = false
        this.text = 'คุณได้ทำการลบข้อมูลเรียบร้อยแล้ว'
        this.snackbarColor = 'success'
        this.snackbar = true
      } else if (this.typeList === 'roleMore') {
        this.detailRoleMore.splice(item, 1)
        this.itemConfirmDelete = []
        this.dialogDelete = false
        this.text = 'คุณได้ทำการลบข้อมูลเรียบร้อยแล้ว'
        this.snackbarColor = 'success'
        this.snackbar = true
      } else {
        this.detailRole.splice(item, 1)
        this.itemConfirmDelete = []
        this.dialogDelete = false
        this.text = 'คุณได้ทำการลบข้อมูลเรียบร้อยแล้ว'
        this.snackbarColor = 'success'
        this.snackbar = true
      }
    },
    async submitData () {
      this.dialogConfirm = false
      var duplicate = []
      var duplicateMore = []
      var permissionList = []
      var permissionMoreList = []
      var empList = []
      for (let index = 0; index < this.detailRole.length; index++) {
        permissionList.push(this.detailRole[index].roleName)
      }
      for (let index = 0; index < this.detailRoleMore.length; index++) {
        permissionMoreList.push({
          role: this.detailRoleMore[index].roleName,
          groupCompanyId: this.detailRoleMore[index].groupCompany,
          companyId: this.detailRoleMore[index].company
        })
      }
      for (let index = 0; index < this.employeeList.length; index++) {
        empList.push(this.employeeList[index]._id)
      }
      const obj = {
        empId: empList,
        permission: permissionList,
        permissionMore: permissionMoreList
      }
      var filterValue = this.detailRole.filter(r => {
        if (r.roleName === '') {
          this.$refs.form.validate()
          return r
        }
      })
      var filterValueMore = this.detailRoleMore.filter(r => {
        if (r.roleName === '' || r.company === '' || r.groupCompany === '') {
          this.$refs.form.validate()
          return r
        }
      })
      for (let index = 0; index < this.detailRole.length; index++) {
        duplicate.push(this.detailRole[index].roleName)
      }
      var findDuplicates = arr => arr.filter((item, index) => arr.indexOf(item) !== index)
      var allDup = [...new Set(findDuplicates(duplicate))]

      for (let index = 0; index < this.detailRoleMore.length; index++) {
        duplicateMore.push(this.detailRoleMore[index].roleName)
      }
      var findDuplicatesMore = arr => arr.filter((item, index) => arr.indexOf(item) !== index)
      var allDupMore = [...new Set(findDuplicatesMore(duplicateMore))]
      if (filterValue.length !== 0 || filterValueMore.length !== 0) {
        this.$refs.form.validate()
        swal('คำเตือน', 'กรุณากรอกข้อมูลให้ครบ', 'warning')
      } else {
        if (allDup.length > 0) {
          swal('คำเตือน', 'มีข้อมูลสิทธิ์การใช้งานหลักของพนักงานซ้ำกัน', 'warning')
        } else if (allDupMore.length > 0) {
          swal('คำเตือน', 'มีข้อมูลสิทธิ์การใช้งานเพิ่มเติมของพนักงานซ้ำกัน', 'warning')
        } else {
          try {
            const res = await updateRolePerson(obj, this.tokenUser)
            if (res.success) {
              swal('สำเร็จ', 'กำหนดสิทธิ์การใช้งานสำเร็จ', 'success', {
                button: false,
                timer: 2000
              })
              this.loading = false
              this.$router.go(-1)
            } else {
              swal('ผิดพลาด', `${this.alertText[res.data.msg] || ''} กรุณาลองใหม่อีกครั้ง`, 'error', {
                button: false,
                timer: 2000
              })
            }
          } catch (error) {
            console.log(error)
            swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
              button: false,
              timer: 2000
            })
          } finally {
            this.loading = false
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.border-table-employee {
  border-radius: 10px;
  border: 1px solid rgb(229, 236, 238);
}

table > tbody > tr > td.fixed:nth-last-child(1),
table > thead > tr > th.fixed:nth-last-child(1) {
  position: sticky !important;
  position: -webkit-sticky !important;
  right: 0;
  /* z-index: 9997; */
  background: white;
  /* background: transparent; */
  -webkit-box-shadow: -1px 0px 3px -1px rgba(0, 0, 0, 0.19);
  -moz-box-shadow: -1px 0px 3px -1px rgba(0, 0, 0, 0.19);
  box-shadow: -1px 0px 3px -1px rgba(0, 0, 0, 0.19);
}

table > tbody > tr:hover > td.fixed:nth-last-child(1), table > thead > tr:hover > th.fixed:nth-last-child(1) {
  background: #eeeeee;
}

table > thead > tr > th.fixed:nth-last-child(1) {
  /* z-index: 9998; */
  background-color: #F8F9FB;
}
.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0 !important;
}
.v-input {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 14px;
}
.txt-font {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 5px;
  color: #757575;
}
.txt-head {
  font-family: 'Sarabun', sans-serif;
  font-weight: bold;
}
.round1 {
  border: 1px solid rgb(165, 163, 163);
  border-radius: 5px;
}
.right {
  margin: auto;
  width: 60%;
  border: 3px solid #73AD21;
  padding: 10px;
}
.head-expand {
  background-color: #C5E1A5 ;
}
.box-tooltip {
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: row;
  width: 20vw;
  height: 12vh;
  font-family: 'Open Sans';
}
.ra-text-in-button-editRolePerson {
  font-family: 'Sarabun', sans-serif;
  /* font-weight: normal; */
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
}

</style>
